import { API_USER_SERVICE } from "../config/Constants";
import { 
    IItemTypeRequestDTO, 
    ICategoryRequestDTO,  
    IItemRequestDTO, 
} from "../interfaces/InventorySettings";
import { getRequest, postRequest, putRequest } from "./Rest";

// ItemType APIs

export const getAllItemTypes = async () => {
    const path = `${API_USER_SERVICE}/item-type`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

export const createItemType = async (dto: IItemTypeRequestDTO) => {
    const path = `${API_USER_SERVICE}/item-type`;
    const response = await postRequest(path, dto);
    return response;
};

export const updateItemType = async (id: number, dto: IItemTypeRequestDTO) => {
    const path = `${API_USER_SERVICE}/item-type/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

// Category APIs

export const createCategory = async (dto: ICategoryRequestDTO) => {
    const path = `${API_USER_SERVICE}/category`;
    const response = await postRequest(path, dto);
    return response;
};

export const updateCategory = async (id: number, dto: ICategoryRequestDTO) => {
    const path = `${API_USER_SERVICE}/category/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

export const getCategoriesByTypeId = async (typeId: number) => {
    const path = `${API_USER_SERVICE}/category/byType/${typeId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};

// Item APIs

export const createItem = async (dto: IItemRequestDTO) => {
    const path = `${API_USER_SERVICE}/item`;
    const response = await postRequest(path, dto);
    return response;
};

export const updateItem = async (id: number, dto: IItemRequestDTO) => {
    const path = `${API_USER_SERVICE}/item/${id}`;
    const response = await putRequest(path, dto);
    return response;
};

export const getItemsByCategoryId = async (categoryId: number) => {
    const path = `${API_USER_SERVICE}/item/byCategory/${categoryId}`;
    const response = await getRequest(path);
    const dataResponse = response?.rawResponse?.data?.data;
    return dataResponse;
};